import { TermsContainer, T300 } from "./SharedStyles";
import I18n from "../../../translations/i18n";

const TermsPrivacy = () => {
  return (
    <TermsContainer>
      <T300 onClick={() => window.open('https://example.com/terms', '_blank')}>
         {I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.terms`)}
      </T300>
      <T300>|</T300>
      <T300 onClick={() => window.open('https://theguestbook.com/privacy', '_blank')}>
         {I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.privacy_policy`)}
      </T300>
   </TermsContainer>
  )
}

export default TermsPrivacy